var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 8a2.666 2.666 0 1 0 0-5.334 2.666 2.666 0 1 0 0 5.333zm0 1.333c-1.78 0-5.334.893-5.334 2.666v1.334h10.667v-1.334c0-1.773-3.554-2.666-5.334-2.666z"
})));
export default SvgUser;